
import React, { Component } from 'react'
import {Button} from 'reactstrap'
import {Link} from 'react-static'
import { resetPassword } from '../actions/account'

const INITIAL_STATE = {
  email: '',
  error: null,
  isSubmitting: false
}

class ForgotPasswordForm extends Component {
  constructor (props) {
    super(props)

    this.state = { ...INITIAL_STATE }
  }

  onSubmit = event => {
    event.preventDefault()
    const { email } = this.state

    this.setState({isSubmitting: true})
    resetPassword(email)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }))
      })
      .catch(error => this.setState({error, isSubmitting: false}))
  }

  render () {
    const {
      email,
      error,
    } = this.state

    const isInvalid = email === '' || this.state.isSubmitting

    return (
      <form onSubmit={this.onSubmit}>
        { error && <p>{error.message}</p> }

        <div className="alert alert-success alert-dismissable">
          Geben Sie bitte Ihre <b>Email</b> ein und wir senden Ihnen weitere
          Anleitungen zu!
        </div>
        <div className="form-group m-b-0">
          <div className="input-group">
            <input
              value={this.state.email}
              className='form-control'
              onChange={event => this.setState({email: event.target.value})}
              type="text"
              placeholder="Email Address"/>
            <span className="input-group-append">
              <Button disabled={isInvalid} color="primary" className="float-right">
                {this.state.isSubmitting ? 'Bitte warten...' : 'zurücksetzen'}
              </Button>
            </span>
          </div>
        </div>

        <div className="form-group row m-t-30">
          <div className="col-12 text-center">
            <Link to='/signin'>Zurück zur Anmeldung</Link>
          </div>
        </div>

      </form>
    )
  }
}

export default ForgotPasswordForm



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/ForgotPasswordForm.js